import {
  type Context,
  createContext,
  type Dispatch,
  type SetStateAction,
} from 'react';

import type { ChipOwnProps } from '../../chip/types/chip.js';
import type { ChipGroupReducerActions } from '../state/chip-group-state-reducer.js';

/**
 * The chip that should receive focus after being revealed, along with
 * whether the focus ring should be shown. The ring is only shown when the
 * reveal was triggered via keyboard.
 * @internal
 */
export type PendingFocusChip = {
  uniqueId: string;
  showFocusRing: boolean;
} | null;

/** @internal */
export type InternalChipGroupContextProps =
  | {
      chipGroupId?: string;
      expanded?: boolean;
      disabled?: boolean;
      size?: ChipOwnProps['size'];
      allChipsFit?: boolean;
      dispatch: Dispatch<ChipGroupReducerActions>;
      setExpanded: Dispatch<SetStateAction<boolean>>;
      pendingFocusChip: PendingFocusChip;
      setPendingFocusChip: Dispatch<SetStateAction<PendingFocusChip>>;
    }
  | undefined;

/**
 * The _InternalChipGroupContext provides access to required states and callbacks.
 * @internal
 */
export const InternalChipGroupContext: Context<InternalChipGroupContextProps> =
  createContext<InternalChipGroupContextProps>(undefined);
